module.exports = __webpack_public_path__ + "static/media/roberts.49779bd8.png";